import React from "react";
import { Input, Switch } from "@showitinc/showit-wc";

import VideoServiceURLParser from "../../utils/VideoServiceURLParser";
import AppConstants from "../../constants/AppConstants";
import { initFormatter } from "../../utils/PropertyFormatters";
import {
  AUTO_PLAY,
  CONTROL_COLOR,
  LOOP,
  SHOW_BYLINE,
  SHOW_PORTRAIT,
  SHOW_TITLE,
  VIDEO_ID,
} from "../../constants/VideoConstants";
import ColorPicker from "../../app2components/base/ColorPicker";

const { UPDATE_ACTION_DELETE, UPDATE_ACTION_SET } = AppConstants;

// Vimeo Default
const DEFAULT_CONTROL_COLOR = "#00adef";

const VideoVimeoSettings = ({ element, isLocked, onPropChange }) => {
  const _onIDChange = (propInfo) => {
    const info = VideoServiceURLParser.parse(propInfo.value);
    onPropChange({ ...propInfo, value: info ? info.id : propInfo.value });
  };

  const _onSwitch = (propInfo) => {
    const { defaultValue } = propInfo;
    const value = propInfo.value ? 1 : 0;

    onPropChange({
      ...propInfo,
      value,
      action: defaultValue === value ? UPDATE_ACTION_DELETE : UPDATE_ACTION_SET,
    });
  };

  const separatePath = (path) => path.split(".");
  const getValue = (path, fallback) => element.getIn(separatePath(path), fallback);
  const prepChange = (path, defaultValue) => [path, getValue(path), true, false, defaultValue];

  const { onChange: onIdChange } = initFormatter(_onIDChange);
  const { onChange: onSwitch } = initFormatter(_onSwitch);
  const { onChange } = initFormatter(onPropChange);

  const controlColor = getValue(CONTROL_COLOR, DEFAULT_CONTROL_COLOR);

  return (
    <div>
      <Input
        disabled={isLocked}
        label="Vimeo ID"
        onSIBeforeChange={onIdChange(...prepChange(VIDEO_ID))}
        onSIInput={onIdChange(...prepChange(VIDEO_ID))}
        reserveContext
        value={getValue(VIDEO_ID, "")}
        bordered
        placeholder="Enter ID"
      />
      <ColorPicker
        color={controlColor}
        disabled={isLocked}
        label="Control Color"
        onSIBeforeChange={onChange(CONTROL_COLOR, controlColor, true, false, DEFAULT_CONTROL_COLOR)}
        onSIChange={onChange(CONTROL_COLOR, controlColor, true, false, DEFAULT_CONTROL_COLOR)}
        onSIInput={onChange(CONTROL_COLOR, controlColor, false, false, DEFAULT_CONTROL_COLOR)}
      />
      <Switch
        checked={getValue(AUTO_PLAY, false)}
        disabled={isLocked}
        label="Autoplay"
        onSIChange={onSwitch(...prepChange(AUTO_PLAY, getValue(AUTO_PLAY, 0)))}
        reserveContext
      />
      <Switch
        checked={getValue(LOOP, false)}
        disabled={isLocked}
        label="Loop"
        onSIChange={onSwitch(...prepChange(LOOP, getValue(LOOP, 0)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_TITLE, true)}
        disabled={isLocked}
        label="Show Title"
        onSIChange={onSwitch(...prepChange(SHOW_TITLE, getValue(SHOW_TITLE, 1)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_BYLINE, true)}
        disabled={isLocked}
        label="Show Byline"
        onSIChange={onSwitch(...prepChange(SHOW_BYLINE, getValue(SHOW_BYLINE, 1)))}
        reserveContext
      />
      <Switch
        checked={getValue(SHOW_PORTRAIT, true)}
        disabled={isLocked}
        label="Show Portrait"
        onSIChange={onSwitch(...prepChange(SHOW_PORTRAIT, getValue(SHOW_PORTRAIT, 1)))}
        reserveContext
      />
    </div>
  );
};

export default VideoVimeoSettings;
